var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},_vm._l((_vm.dates),function(date,index){return _c('Day',{key:index,staticClass:"mx-2",attrs:{"date":date,"active":_vm.$moment(date).valueOf() === _vm.$moment(_vm.activeDate).valueOf()},on:{"slectedDate":function($event){_vm.selectedDate = $event}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }